(function () {
  "use strict";

  const ROOT_SELECTOR = "[data-kit-set-command]";

  function bindAutoHeightUpdates(swiper, section) {
    var updateHeight = function () {
      if (swiper && !swiper.destroyed) {
        swiper.updateAutoHeight(0);
      }
    };

    section.querySelectorAll(".kit-set-command__visual img").forEach(function (img) {
      if (img.complete) return;
      img.addEventListener("load", updateHeight, { once: true });
      img.addEventListener("error", updateHeight, { once: true });
    });

    swiper.on("slideChangeTransitionEnd", updateHeight);
    swiper.on("resize", updateHeight);

    // iOS：非当前 slide 的图切页后才解码，延迟再量一次高度
    swiper.on("slideChange", function () {
      window.requestAnimationFrame(function () {
        updateHeight();
        window.setTimeout(updateHeight, 120);
      });
    });
  }

  function initSection(section) {
    if (!section || section.__kitSetCommandReady || typeof Swiper === "undefined") {
      return;
    }

    var bars = Array.from(section.querySelectorAll("[data-command-progress]"));
    var swiperEl = section.querySelector("[data-command-swiper]");

    if (!swiperEl || bars.length === 0) {
      return;
    }

    section.__kitSetCommandReady = true;

    var setActive = function (index) {
      bars.forEach(function (bar, barIndex) {
        var active = barIndex === index;
        bar.classList.toggle("is-active", active);
        bar.setAttribute("aria-selected", active ? "true" : "false");
      });
    };

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      speed: 500,
      autoHeight: true,
      allowTouchMove: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      on: {
        init: function (instance) {
          setActive(instance.activeIndex);
          bindAutoHeightUpdates(instance, section);
          instance.updateAutoHeight(0);
        },
        slideChange: function (instance) {
          setActive(instance.activeIndex);
        },
      },
    });

    bars.forEach(function (bar, index) {
      bar.addEventListener("click", function () {
        swiper.slideTo(index);
      });
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section =
      event.target.querySelector(ROOT_SELECTOR) || event.target.closest(ROOT_SELECTOR);
    if (section) {
      section.__kitSetCommandReady = false;
      initSection(section);
    }
  });
})();
